import Vue from "vue";
import Router from "vue-router";
import verificaAutenticacao from "@/common/middleware/verificaAutenticacao.js";
import redirecionaSeAutenticado from "@/common/middleware/redirecionaSeAutenticado.js";
import store from "@/store/Store";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,

  routes: [
    {
      path: "/",
      redirect: "/dashboard",
      component: () => import("@/layouts/full-layout/FullLayout"),
      children: [
        // dashboard
        {
          name: "dashboard",
          path: "/dashboard",
          meta: {
            middleware: verificaAutenticacao,
          },
          component: () => import("@/views/dashboard/DashboardView"),
        },
        {
          name: "dashboard-admin",
          path: "/dashboard_admin",
          meta: {
            middleware: verificaAutenticacao,
          },
          component: () => import("@/views/dashboard/DashboardAdmin"),
        },

        {
          name: "auditoria",
          path: "/auditoria",
          meta: {
            middleware: verificaAutenticacao,
          },
          component: () => import("@/views/auditoria/Index"),
        },
        {
          name: "pessoas",
          path: "/pessoas",
          meta: {
            middleware: verificaAutenticacao,
          },
          component: () => import("@/views/pessoas/Index"),
        },
        {
          name: "pessoas-formulario",
          path: "/pessoas/form/:id?/",
          props: true,
          meta: {
            middleware: verificaAutenticacao,
          },
          component: () => import("@/views/pessoas/Formulario"),
        },
        {
          name: "usuarios",
          path: "/usuarios",
          meta: {
            middleware: verificaAutenticacao,
          },
          component: () => import("@/views/usuarios/Index"),
        },
        {
          name: "documentos",
          path: "/documentos",
          meta: {
            middleware: verificaAutenticacao,
          },
          component: () => import("@/views/documentos/Index"),
        },
        {
          name: "documentos-formulario",
          path: "/documentos/form/:id?/",
          props: true,
          meta: {
            middleware: verificaAutenticacao,
          },
          component: () => import("@/views/documentos/DocumentosForm"),
        },
        {
          name: "usuarios-formulario",
          path: "/usuarios/form/:id?/",
          props: true,
          meta: {
            middleware: verificaAutenticacao,
          },
          component: () => import("@/views/usuarios/Formulario"),
        },
        {
          name: "fndct",
          path: "/fndct",
          meta: {
            middleware: verificaAutenticacao,
          },
          component: () => import("@/views/fndct/Index"),
        },
        {
          name: "cde",
          path: "/cde",
          meta: {
            middleware: verificaAutenticacao,
          },
          component: () => import("@/views/cde/Index"),
        },
        {
          name: "mme",
          path: "/mme",
          meta: {
            middleware: verificaAutenticacao,
          },
          component: () => import("@/views/mme/Index"),
        },
        {
          name: "perfis",
          path: "/perfis",
          meta: {
            middleware: verificaAutenticacao,
          },
          component: () => import("@/views/perfis/Index"),
        },
        {
          name: "perfis-formulario",
          path: "/perfis/form/:id?/",
          meta: {
            middleware: verificaAutenticacao,
          },
          component: () => import("@/views/perfis/Formulario"),
        },
        {
          name: "empresas",
          path: "/empresas",
          meta: {
            middleware: verificaAutenticacao,
          },
          component: () => import("@/views/empresas/Index"),
        },
        {
          name: "empresas-formulario",
          path: "/empresas/form/:id?/",
          props : true,
          meta: {
            middleware: verificaAutenticacao,
          },
          component: () => import("@/views/empresas/Formulario"),
        },
        {
          name: "aprovacao-usuario",
          path: "/usuarios/aprovacao-usuario/",
          meta: {
            middleware: verificaAutenticacao,
          },
          component: () => import("@/views/usuarios/Aprovacao"),
        },
        {
          name: "aprovacao-usuario-formulario",
          path: "/usuarios/aprovacao-usuario/editar/",
          props: true,
          meta: {
            middleware: verificaAutenticacao,
          },
          component: () => import("@/views/usuarios/FormularioAprovacao"),
        },
        
        //Menu perfil
        {
          name: "meu-perfil",
          path: "/meu-perfil",
          meta: {
            middleware: verificaAutenticacao,
          },
          component: () => import("@/views/pessoas/MeuPerfil.vue"),
        },

        //Rotas de demanda
        {
          name: "demanda",
          path: "demanda",
          meta: { middleware: verificaAutenticacao, },
          component: () => import("@/views/demanda/DemandaRoot.vue"),
          children: [
            {
              name: "demanda-lista",
              path: "/",
              meta: { middleware: verificaAutenticacao, },
              component: () => import("@/views/demanda/DemandaList.vue"),
            },
            {
              name: "demanda-formulario",
              path: "formulario/:id?/",
              props: true,
              meta: { middleware: verificaAutenticacao, },
              component: () => import("@/views/demanda/DemandaForm.vue"),
            }
          ]
        },

        //Rotas do planejamento estratégico
        {
          name: "planejamento-estrategico",
          path: "planejamento-estrategico",
          meta: { middleware: verificaAutenticacao, },
          component: () => import("@/views/planejamento_estrategico/PlanejamentoRoot.vue"),
          
          children: [
            {
              name: "planejamento-estrategico-lista",
              path: "/",
              meta: { middleware: verificaAutenticacao, },
              component: () => import("@/views/planejamento_estrategico/PlanejamentoList.vue"),
            },
            {
              name: "planejamento-estrategico-formulario",
              path: "formulario/:id?/",
              props: true,
              meta: { middleware: verificaAutenticacao, },
              component: () => import("@/views/planejamento_estrategico/PlanejamentoForm.vue"),
            }
          ]
        },

        //Rotas equipe
        {
          name: "equipe",
          path: "equipe",
          meta: { middleware: verificaAutenticacao, },
          component: () => import("@/views/equipes/EquipesLista.vue"),
        },
        {
          name: "equipe-formulario",
          path: "equipe_formulario/:id?/",
          props: true,
          meta: { middleware: verificaAutenticacao, },
          component: () => import("@/views/equipes/EquipesForm.vue"),
        },

        //Rotas do proposta
        {
          name: "proposta",
          path: "proposta",
          meta: { middleware: verificaAutenticacao, },
          component: () => import("@/views/proposta/PropostaRoot.vue"),
          
          children: [
            {
              name: "proposta-todos-lista",
              path: "/proposta_todos",
              props: {
                endpoint : "Proposta",
                texto : "Propostas",
              },
              meta: { middleware: verificaAutenticacao, },
              component: () => import("@/views/proposta/PropostaLista.vue"),
            },
            {
              name: "proposta-executora-lista",
              path: "/proposta_executora",
              props: {
                endpoint : "Proposta",
                texto : "Minhas propostas",
              },
              meta: { middleware: verificaAutenticacao, },
              component: () => import("@/views/proposta/PropostaLista.vue"),
            },
            {
              name: "proposta-proponente-lista",
              path: "/proposta_proponente",
              props: {
                endpoint : "PropostaEmpresaProponente",
                texto : "Propostas",
              },
              meta: { middleware: verificaAutenticacao, },
              component: () => import("@/views/proposta/PropostaLista.vue"),
            },
            {
              name: "proposta-executora-associada-lista",
              path: "/proposta_executora_associada",
              props: {
                endpoint : "PropostaEmpresaExecutora",
                texto : "Propostas associadas",
              },
              meta: { middleware: verificaAutenticacao, },
              component: () => import("@/views/proposta/PropostaLista.vue"),
            },
            {
              name: "proposta-proponente-cooperada-lista",
              path: "/proposta_proponente_cooperada",
              props: {
                endpoint : "PropostaEmpresaCooperada",
                texto : "Propostas cooperadas",
              },
              meta: { middleware: verificaAutenticacao, },
              component: () => import("@/views/proposta/PropostaLista.vue"),
            },
            {
              name: "proposta-executora-formulario",
              path: "formulario_executora",
              meta: { middleware: verificaAutenticacao, },
              component: () => import("@/views/proposta/PropostaFormulario.vue"),
            },
            {
              name: "proposta-executora-detalhamento",
              path: "detalhamento_executora/:id?/",
              props(route) {                 
                return { id: route.params.id, tipoProposta : "executora", texto : "Minhas propostas", rota : "proposta-executora-lista" };
              },
              meta: { middleware: verificaAutenticacao, },
              component: () => import("@/views/proposta/PropostaDetalhamento.vue"),
            },
            {
              name: "proposta-proponente-detalhamento",
              path: "detalhamento_proponente/:id?/",
              props(route) {                 
                return { id: route.params.id, tipoProposta : "proponente", texto : "Propostas", rota : "proposta-proponente-lista" };
              },
              meta: { middleware: verificaAutenticacao, },
              component: () => import("@/views/proposta/PropostaDetalhamento.vue"),
            },
            {
              name: "proposta-executora-associada-detalhamento",
              path: "detalhamento_executora_associada/:id?/",
              props(route) {                 
                return { id: route.params.id, tipoProposta : "associada",  texto : "Propostas associadas", rota : "proposta-executora-associada-lista" };
              },
              meta: { middleware: verificaAutenticacao, },
              component: () => import("@/views/proposta/PropostaDetalhamento.vue"),
            },
            {
              name: "proposta-proponente-cooperada-detalhamento",
              path: "detalhamento_proponente_cooperada/:id?/",
              props(route) {                 
                return { id: route.params.id, tipoProposta : "cooperada", texto : "Propostas cooperadas", rota : "proposta-proponente-cooperada-lista" };
              },
              meta: { middleware: verificaAutenticacao, },
              component: () => import("@/views/proposta/PropostaDetalhamento.vue"),
            }
          ]
        },

        //Rotas do projeto
        {
          name: "projeto",
          path: "projeto",
          meta: { middleware: verificaAutenticacao, },
          component: () => import("@/views/projeto/ProjetoRoot.vue"),
          
          children: [
            {
              name: "projeto-todos-lista",
              path: "/projeto_todos",
              props: {
                endpoint : "Projeto",
                texto : "Projetos P&D",
              },
              meta: { middleware: verificaAutenticacao, },
              component: () => import("@/views/projeto/ProjetoList.vue"),
            },
            {
              name: "projeto-lista",
              path: "/",
              props: {
                endpoint : "Projeto",
                texto : "Meus projetos P&D",
              },
              meta: { middleware: verificaAutenticacao, },
              component: () => import("@/views/projeto/ProjetoList.vue"),
            },
            {
              name: "projeto-lista-executora-criadora",
              path: "/projeto_executora_criadora",
              meta: { middleware: verificaAutenticacao, },
              props: {
                endpoint : "ProjetoEmpresaExecutoraCriadora",
                texto : "Projetos P&D",
              },
              component: () => import("@/views/projeto/ProjetoList.vue"),
            },
            {
              name: "projeto-lista-executora-associada",
              path: "/projeto_executora_associada",
              meta: { middleware: verificaAutenticacao, },
              props: {
                endpoint : "ProjetoEmpresaExecutora",
                texto : "Projetos P&D associados",
              },
              component: () => import("@/views/projeto/ProjetoList.vue"),
            }, 
            {
              name: "projeto-lista-proponente-cooperada",
              path: "/projeto_proponente_cooperada",
              meta: { middleware: verificaAutenticacao, },
              props: {
                endpoint : "ProjetoEmpresaCooperada",
                texto : "Projetos P&D cooperados",
              },
              component: () => import("@/views/projeto/ProjetoList.vue"),
            },            
            {
              name: "projeto-detalhamento",
              path: "/projeto_detalhamento/:id?/",
              meta: { middleware: verificaAutenticacao, },
              props(route) {                 
                return { id: route.params.id, tipoProjeto : "proponente" 
                  , texto : "Meus projetos P&D", rota : "projeto-lista"
              };
              },
              component: () => import("@/views/projeto/ProjetoDetalhamento.vue"),
            },
            {
              name: "projeto-detalhamento-executora-criadora",
              path: "/projeto_detalhamento_executora_detalhamento/:id?/",
              meta: { middleware: verificaAutenticacao, },
              props(route) {                 
                return { id: route.params.id, tipoProjeto : "executora",
                  texto : "Projetos P&D", rota : "projeto-lista-executora-criadora"
              };
              },
              component: () => import("@/views/projeto/ProjetoDetalhamento.vue"),
            },
            {
              name: "projeto-detalhamento-executora-associada",
              path: "/projeto_detalhamento_executora_associada_detalhamento/:id?/",
              meta: { middleware: verificaAutenticacao, },
              props(route) {                 
                return { id: route.params.id, tipoProjeto : "associada",
                  texto : "Projetos P&D associados", rota : "projeto-lista-executora-associada"
              };
              },
              component: () => import("@/views/projeto/ProjetoDetalhamento.vue"),
            },
            {
              name: "projeto-detalhamento-proponente-cooperada",
              path: "/projeto_detalhamento_proponente_cooperada_detalhamento/:id?/",
              meta: { middleware: verificaAutenticacao, },
              props(route) {                 
                return { id: route.params.id, tipoProjeto : "cooperada",
                  texto : "Projetos P&D cooperados", rota : "projeto-lista-proponente-cooperada"
              };
              },
              component: () => import("@/views/projeto/ProjetoDetalhamento.vue"),
            },
          ]
        },

        {
          name: "movimentacao-financeira",
          path: "movimentacao_financeira",
          meta: { middleware: verificaAutenticacao, },
          component: () => import("@/views/movimentacao_financeira/MovimentacaoFinanceira.vue"),
        },

        {
          name: "contrato-licenca",
          path: "contrato_licenca",
          meta: { middleware: verificaAutenticacao, },
          component: () => import("@/views/contrato_licenca/ContratoLicencaLista.vue"),
        },
        {
          name: "contrato-licenca-formulario",
          path: "contrato_licenca_formulario/:id?/",
          meta: { middleware: verificaAutenticacao, },
          props : true,
          component: () => import("@/views/contrato_licenca/ContratoLicencaFormulario.vue"),
        },
        
        
        {
          name: "alertas",
          path: "alertas",
          meta: { middleware: verificaAutenticacao, },
          component: () => import("@/views/alertas/AlertasLista.vue"),
        },
        {
          name: "alertas-detalhes",
          path: "alertas/:id?/",
          meta: { middleware: verificaAutenticacao, },
          component: () => import("@/views/alertas/AlertasDetalhes.vue"),
          props : true
        },

        {
          name: "projecao-financeira",
          path: "projecao_financeira",
          meta: { middleware: verificaAutenticacao, },
          component: () => import("@/views/projecao_financeira/ProjecaoFinanceira.vue"),
        },

        {
          name: "projeto_rn_219",
          path: "projeto_rn_219",
          meta: { middleware: verificaAutenticacao, },
          component: () => import("@/views/projeto/ProjetoRoot.vue"),
          
          children: [
            {
              name: "projeto-rn-219-lista",
              path: "/projeto_rn_219",
              props: { endpoint : "", telaDetalhes : "" },
              meta: { middleware: verificaAutenticacao, },
              component: () => import("@/views/projeto_rn_219/ProjetoRNLista.vue"),
            },
            {
              name: "projeto-rn-detalhamento",
              path: "/projeto_rn_detalhamento/:id?/",
              props : true,
              meta: { middleware: verificaAutenticacao, },
              component: () => import("@/views/projeto_rn_219/ProjetoRNDetalhamento.vue"),
            },  
            {
              name: "projeto-rn-novo",
              path: "/projeto_rn_novo",
              meta: { middleware: verificaAutenticacao, },
              component: () => import("@/views/projeto_rn_219/ProjetoRNDetalhamento.vue"),
            },            
          ]
        },

        {
          name: "projeto_316",
          path: "projeto_316",
          meta: { middleware: verificaAutenticacao, },
          component: () => import("@/views/projeto/ProjetoRoot.vue"),
          
          children: [
            {
              name: "projeto-316-lista",
              path: "/projeto_316",
              props: { endpoint : "", telaDetalhes : "" },
              meta: { middleware: verificaAutenticacao, },
              component: () => import("@/views/projeto_rn_316/ProjetoRNLista.vue"),
            },
            {
              name: "projeto-316-detalhamento",
              path: "/projeto_316_detalhamento/:id?/",
              props : true,
              meta: { middleware: verificaAutenticacao, },
              component: () => import("@/views/projeto_rn_316/ProjetoRNDetalhamento.vue"),
            },  
            {
              name: "projeto-316-novo",
              path: "/projeto_316_novo",
              meta: { middleware: verificaAutenticacao, },
              component: () => import("@/views/projeto_rn_316/ProjetoRNDetalhamento.vue"),
            },            
          ]
        },

         //Rotas do projeto de gestao
         {
          name: "projeto_gestao",
          path: "projeto_gestao",
          meta: { middleware: verificaAutenticacao, },
          component: () => import("@/views/projeto/ProjetoRoot.vue"),
          
          children: [
            {
              name: "projeto-gestao-todos",
              path: "/projeto_gestao_todos",
              props: { endpoint : "", telaDetalhes : "" },
              meta: { middleware: verificaAutenticacao, },
              component: () => import("@/views/projeto_gestao/ProjetoGestaoLista.vue"),
            },
            {
              name: "projeto-gestao-formulario",
              path: "/projeto_gestao_novo",
              props: { endpoint : "", telaDetalhes : "" },
              meta: { middleware: verificaAutenticacao, },
              component: () => import("@/views/projeto_gestao/ProjetoGestaoForm.vue"),
            },
            {
              name: "projeto-gestao-proponente-lista",
              path: "/projeto_gestao_proponente",
              props: { endpoint : "ProjetoGestao", telaDetalhes : "projeto-gestao-proponente-detalhamento" },
              meta: { middleware: verificaAutenticacao, },
              component: () => import("@/views/projeto_gestao/ProjetoGestaoLista.vue"),
            },
            {
              name: "projeto-gestao-cooperada-lista",
              path: "/projeto_gestao_cooperada",
              props: { 
                endpoint : "ProjetoGestaoCooperada", 
                telaDetalhes : "projeto-gestao-cooperada-detalhamento" 
              },
              meta: { middleware: verificaAutenticacao, },
              component: () => import("@/views/projeto_gestao/ProjetoGestaoLista.vue"),
            },
            {
              name: "projeto-gestao-proponente-detalhamento",
              path: "/projeto_gestao_proponente_detalhes/:id?/",
              props(route) {                 
                return { id: route.params.id, endpoint : "ProjetoGestao", nomeIdProjeto : "ProjetoGestaoId" };
              },
              meta: { middleware: verificaAutenticacao, },
              component: () => import("@/views/projeto_gestao/ProjetoGestaoDetalhamento.vue"),
            },
            {
              name: "projeto-gestao-cooperada-detalhamento",
              path: "/projeto_gestao_cooperada_detalhes/:id?/",
              props(route) {                 
                return { 
                  id: route.params.id, 
                  endpoint : "ProjetoGestaoCooperada", 
                  nomeIdProjeto : "ProjetoGestaoCooperadaId" };
              },
              meta: { middleware: verificaAutenticacao, },
              component: () => import("@/views/projeto_gestao/ProjetoGestaoDetalhamento.vue"),
            },
          ]
        },

        //Rotas de configurações
        {
          name: "configs",
          path: "configs",
          meta: { middleware: verificaAutenticacao, },
          component: () => import("@/views/configs/ConfigsRoot.vue"),
          children: [
            {
              name: "termos",
              path: "termos",
              meta: { middleware: verificaAutenticacao, },
              component: () => import("@/views/configs/termos/TermosRoot.vue"),
              children: [
                
                {
                  name: "termos-formulario",
                  path: "formulario",
                  meta: { middleware: verificaAutenticacao, },
                  component: () => import("@/views/configs/termos/TermosForm.vue")
                }

              ]
            }
          ]
        },
        

      ],
    },
    {
      path: "/",
      component: () => import("@/layouts/blank-layout/Blanklayout"),
      children: [
        {
          name: "Login",
          path: "login",
          meta: {
            middleware: redirecionaSeAutenticado,
          },
          component: () => import("@/views/autenticacao/Login"),
        },

        {
          name: "Cadastro",
          path: "cadastro",
          meta: {
            middleware: redirecionaSeAutenticado,
          },
          component: () => import("@/views/autenticacao/Cadastro"),
        },
        {
          name: "cadastro_via_email",
          path: "cadastro-via-email",
          props : route => Object.assign({}, route.query, route.params),
          meta: { middleware: redirecionaSeAutenticado, },
          component: () => import("@/views/usuarios/FormularioUsuario"),
        },
        {
          name: "esqueceu-sua-senha",
          path: "esqueceu-sua-senha/",
          meta: {
            middleware: redirecionaSeAutenticado,
          },
          component: () => import("@/views/autenticacao/EsqueceuSenha"),
        },
        {
          name: "resetar-senha",
          path: "resetar-senha/",
          meta: {
            middleware: redirecionaSeAutenticado,
          },
          component: () => import("@/views/autenticacao/ResetarSenha"),
        }
      ],
    },
    {
      path: "*",
      redirect: "/login",
      //component: () => import("@/views/authentication/Error"),
    },
    {
      path: "/",
      redirect: "/login",
      //component: () => import("@/views/authentication/Error"),
    },
  ],
});

// router.beforeResolve((to, from, next) => {
//   if (to.name) {
//     NProgress.start(800);
//   }
//   next();
// });

// router.afterEach(() => {
//   NProgress.done();
// });

function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index];

  if (!subsequentMiddleware) return context.next;

  return (...parameters) => {
    context.next(...parameters);
    const nextMiddleware = nextFactory(context, middleware, index + 1);
    subsequentMiddleware({ ...context, next: nextMiddleware });
  };
}

router.beforeEach((to, from, next) => {
  let menuTipo = store.state.LayoutType
  if(menuTipo == 'mobile-sidebar'){
    store.dispatch('setMenuAberto',false)
  }
  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware) ? to.meta.middleware : [to.meta.middleware];

    const context = {
      from,
      next,
      router,
      to,
    };
    const nextMiddleware = nextFactory(context, middleware, 1);

    return middleware[0]({ ...context, next: nextMiddleware });
  }


  return next();
});

export default router;
